// AI-assisted. Reviewed by: [name] on [date]. Tests: ✅. No unreviewed auth changes.
import { Outlet } from 'react-router-dom';
import AppSidebar from './AppSidebar';
import AppTopBar from './AppTopBar';

export default function AppLayout() {
  return (
    <div className="flex h-screen overflow-hidden bg-white">
      {/* Fixed-width sidebar — compact per reference design */}
      <aside className="w-[180px] flex-shrink-0 flex flex-col overflow-y-auto bg-brand-sidebar-bg">
        <AppSidebar />
      </aside>

      {/* Right column: top bar + page content */}
      <div className="flex min-w-0 flex-1 flex-col">
        <div>
          <AppTopBar />
        </div>
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
